export const ORGANIZATION = {
  "@type": "Organization",
  "@id": "__ORIGIN__/#organization",
  name: "erth. escapes",
  url: "__ORIGIN__/",
  logo: "__ORIGIN__/images/erth-black.png",
  description:
    "erth. escapes creates innovative spaces that harmonize with nature: eco-conscious residences and immersive retreats across India.",
  email: "info@area83.in",
  telephone: "+91 80463 96067",
  contactPoint: [
    { "@type": "ContactPoint", telephone: "+91 80463 96067", contactType: "reservations", areaServed: "IN", availableLanguage: ["en"] },
    { "@type": "ContactPoint", telephone: "+91 88846 08383", contactType: "customer support", areaServed: "IN", availableLanguage: ["en"] },
  ],
};

export const DUNE_LODGING = {
  "@type": "LodgingBusiness",
  "@id": "__ORIGIN__/dune-villas#lodging",
  name: "Dune Villas at Area 83",
  url: "__ORIGIN__/dune-villas",
  image: "__ORIGIN__/images/exterior-hero.webp",
  description:
    "Two identical private six-bedroom villas near Bengaluru, each with a swimming pool, sleeping 12+2 guests, with breakfast and dinner included.",
  brand: { "@id": "__ORIGIN__/#organization" },
  parentOrganization: { "@id": "__ORIGIN__/#organization" },
  telephone: "+91 80463 96067",
  email: "info@area83.in",
  address: {
    "@type": "PostalAddress",
    streetAddress: "No. 313, Off Bannerghatta Road, Bilwaradahalli, Shanbhoganahalli",
    addressLocality: "Bengaluru",
    addressRegion: "Karnataka",
    postalCode: "560083",
    addressCountry: "IN",
  },
  checkinTime: "15:00",
  checkoutTime: "11:00",
  numberOfRooms: 6,
  petsAllowed: false,
  amenityFeature: [
    "Private swimming pool",
    "Breakfast and dinner included",
    "Kitchen",
    "Air conditioning",
    "Free on-site parking",
    "Electric kettle",
    "Geyser",
    "Hair dryer",
    "Iron box",
  ].map((name) => ({ "@type": "LocationFeatureSpecification", name, value: true })),
  priceRange: "From ₹60,000 per villa per night",
};

export const faqSchema = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `__ORIGIN__${it.path}`,
  })),
});

export const graph = (...nodes) => ({ "@context": "https://schema.org", "@graph": nodes });
